export default __webpack_public_path__ + "static/media/Summoner's Armbands of Imperial Assent.b6347177.jpg";